import isEmpty from 'lodash/isEmpty';

import { LocationTypes } from '../Types';
import {
  getHomeCities,
  getJobCities,
  getCityByLocation,
  getCityBySearchTerm,
  getLocalitiesByCity,
  getLocalitiesByLocation,
} from '../../services/API/LocationAPIService';
import { formatError } from '../../services/AppService';

const DEFAULT_TIMEOUT = 5000;
export default function(state, dispatch) {
  function _dispatch(type, payload) {
    dispatch({ type, payload });
  }
  function _dispatchAPIProgress(status) {
    _dispatch(LocationTypes.IS_API_PROGRESS, status);
  }

  const _resetError = () => {
    _dispatch(LocationTypes.RESET_ERROR);
  };

  const setLocationError = (error, isAutoCancel = true, timeout) => {
    dispatch(LocationTypes.SET_ERROR, { error: formatError(error) });
    if (isAutoCancel) {
      setTimeout(() => {
        _resetError();
      }, timeout || DEFAULT_TIMEOUT);
    }
  };

  function fetchHomeCities(callback) {
    const { cities } = state;
    if (isEmpty(cities)) {
      _dispatchAPIProgress(true);
      getHomeCities()
        .then(data => {
          _dispatchAPIProgress(false);
          _dispatch(LocationTypes.ON_SUCCESS_HOME_CITY_FETCH, data);
          if (callback) {
            callback(data);
          }
        })
        .catch(error => {
          _dispatchAPIProgress(false);
          setLocationError(error);
        });
    }
  }
  function fetchJobCities(callback) {
    const { cities } = state;
    if (isEmpty(cities)) {
      _dispatchAPIProgress(true);
      getJobCities()
        .then(data => {
          _dispatchAPIProgress(false);
          _dispatch(LocationTypes.ON_SUCCESS_JOB_CITY_FETCH, data);
          if (callback) {
            callback(data);
          }
        })
        .catch(error => {
          _dispatchAPIProgress(false);
          setLocationError(error);
        });
    }
  }

  function fetchCityByLocation({ latitude, longitude } = {}) {
    _dispatchAPIProgress(true);
    return new Promise((resolve, reject) => {
      getCityByLocation({ latitude, longitude })
        .then(data => {
          _dispatchAPIProgress(false);
          resolve(data);
        })
        .catch(error => {
          _dispatchAPIProgress(false);
          reject(error);
        });
    });
  }
  function resetSearchedCity() {
    _dispatch(LocationTypes.ON_SUCCESS_CITY_SEARCH, []);
  }

  function fetchCityBySearchTerm(searchTerm) {
    if (isEmpty(searchTerm)) return;
    _dispatchAPIProgress(true);
    getCityBySearchTerm({ searchTerm })
      .then(data => {
        _dispatchAPIProgress(false);
        _dispatch(LocationTypes.ON_SUCCESS_CITY_SEARCH, data);
      })
      .catch(error => {
        _dispatchAPIProgress(false);
        setLocationError(error);
      });
  }

  function fetchLocalities({ selectedCityCode }) {
    console.log(selectedCityCode);
    _dispatchAPIProgress(true);
    getLocalitiesByCity({ city: selectedCityCode })
      .then(data => {
        _dispatchAPIProgress(false);
        _dispatch(LocationTypes.ON_SUCCESS_LOCALITY_FETCH, data);
      })
      .catch(error => {
        _dispatchAPIProgress(false);
        setLocationError(error);
      });
  }
  function fetchLocalitiesByLocation({ latitude, longitude, selectedCityCode }) {
    _dispatchAPIProgress(true);
    return new Promise((resolve, reject) => {
      getLocalitiesByLocation({ latitude, longitude, city: selectedCityCode })
        .then(data => {
          _dispatchAPIProgress(false);
          resolve(data);
        })
        .catch(error => {
          _dispatchAPIProgress(false);
          reject(error);
        });
    });
  }

  return {
    fetchHomeCities,
    fetchJobCities,
    fetchCityByLocation,
    fetchCityBySearchTerm,
    resetSearchedCity,
    fetchLocalities,
    fetchLocalitiesByLocation,
  };
}
